import { createFileRoute, redirect } from "@tanstack/react-router";

// The dashboard has no distinct home screen: ops arrives looking for a
// transaction. Sending / straight to the first nav item avoids an empty
// landing page that everyone immediately clicks past.
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: "/transactions" });
  },
});
